"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { calculateChildcareSubsidy, calculateHigherChildcareSubsidy, ChildcareSubsidyChildren } from "@/features/tools/lib/childcare-subsidy";
import { ToolData } from ".";
import { Field, FieldLabel } from "@/components/ui/field";
import { Heading } from "@/components/ui/heading";
import { calculateTax } from "@/lib/tax";
function ChildcareSubsidyCalculator(t0) {
  const $ = _c(66);
  const {
    title,
    description
  } = t0;
  const [children, setChildren] = useState("one");
  const [eldestChildCareDays, setEldestChildCareDays] = useState(0);
  const [childCareDays, setChildCareDays] = useState(3);
  const [primaryIncome, setPrimaryIncome] = useState(90000);
  const [secondaryIncome, setSecondaryIncome] = useState(90000);
  const [childCareDayRate, setChildCareDayRate] = useState(180);
  const subsidyPercentage = calculateChildcareSubsidy(primaryIncome + secondaryIncome);
  const higherSubsidyPercentage = calculateHigherChildcareSubsidy(primaryIncome + secondaryIncome, children);
  const childCareDayRateWithSubsidy = Math.round(childCareDayRate - childCareDayRate * subsidyPercentage / 100);
  const eldestChildCareDayRateWithSubsidy = Math.round(childCareDayRate - childCareDayRate * higherSubsidyPercentage / 100);
  const yearlyCost = (eldestChildCareDayRateWithSubsidy * eldestChildCareDays + childCareDayRateWithSubsidy * childCareDays) * 52;
  let t1;
  if ($[0] !== title) {
    t1 = <CardTitle>{title}</CardTitle>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description) {
    t2 = <CardDescription>{description}</CardDescription>;
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <CardHeader>{t1}{t2}</CardHeader>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FieldLabel htmlFor="children">Number of children under 5</FieldLabel>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = value => setChildren(value);
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SelectTrigger id="children"><SelectValue /></SelectTrigger>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SelectContent><SelectItem value="one">One</SelectItem><SelectItem value="more">More than one</SelectItem></SelectContent>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== children) {
    t8 = <Field className="flex-1">{t4}<Select value={children} onValueChange={t5}>{t6}{t7}</Select></Field>;
    $[11] = children;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== children || $[14] !== eldestChildCareDays) {
    t9 = children === "more" ? <Field><FieldLabel htmlFor="eldestChildCareDays">Days of child care for eldest child</FieldLabel><Input id="eldestChildCareDays" value={eldestChildCareDays} onChange={e => setEldestChildCareDays(parseInt(e.target.value))} type="number" min={1} max={20} step={1} /></Field> : null;
    $[13] = children;
    $[14] = eldestChildCareDays;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = children === "more" ? " for remaining children" : "";
  let t11;
  if ($[16] !== t10) {
    t11 = <FieldLabel htmlFor="childCareDays">Days of child care{t10}</FieldLabel>;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = e_0 => setChildCareDays(parseInt(e_0.target.value));
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== childCareDays) {
    t13 = <Input id="childCareDays" value={childCareDays} onChange={t12} type="number" min={1} max={20} step={1} />;
    $[19] = childCareDays;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t11 || $[22] !== t13) {
    t14 = <Field>{t11}{t13}</Field>;
    $[21] = t11;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <FieldLabel htmlFor="childCareDayRate">Child Care Day Rate</FieldLabel>;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = e_1 => setChildCareDayRate(parseInt(e_1.target.value));
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== childCareDayRate) {
    t17 = <Field>{t15}<Input id="childCareDayRate" value={childCareDayRate} onChange={t16} type="number" min={100} max={300} step={10} /></Field>;
    $[26] = childCareDayRate;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <FieldLabel htmlFor="primaryIncome">Primary Income</FieldLabel>;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = e_2 => setPrimaryIncome(parseInt(e_2.target.value));
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== primaryIncome) {
    t20 = <Field className="flex-1">{t18}<Input id="primaryIncome" value={primaryIncome} onChange={t19} type="number" min={0} max={10000000} step={1000} /></Field>;
    $[30] = primaryIncome;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  let t21;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <FieldLabel htmlFor="secondaryIncome">Secondary Income</FieldLabel>;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  let t22;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = e_3 => setSecondaryIncome(parseInt(e_3.target.value));
    $[33] = t22;
  } else {
    t22 = $[33];
  }
  let t23;
  if ($[34] !== secondaryIncome) {
    t23 = <Field className="flex-1">{t21}<Input id="secondaryIncome" value={secondaryIncome} onChange={t22} type="number" min={0} max={10000000} step={1000} /></Field>;
    $[34] = secondaryIncome;
    $[35] = t23;
  } else {
    t23 = $[35];
  }
  let t24;
  if ($[36] !== t20 || $[37] !== t23) {
    t24 = <div className="flex flex-col gap-4 md:flex-row">{t20}{t23}</div>;
    $[36] = t20;
    $[37] = t23;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  let t25;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div>Child Care Subsidy Rate</div>;
    $[39] = t25;
  } else {
    t25 = $[39];
  }
  let t26;
  if ($[40] !== subsidyPercentage) {
    t26 = <div className="flex flex-1 flex-col justify-center gap-2">{t25}<Heading>{subsidyPercentage}%</Heading></div>;
    $[40] = subsidyPercentage;
    $[41] = t26;
  } else {
    t26 = $[41];
  }
  let t27;
  if ($[42] !== higherSubsidyPercentage || $[43] !== subsidyPercentage) {
    t27 = higherSubsidyPercentage !== subsidyPercentage ? <div className="flex flex-1 flex-col justify-center gap-2"><div>Higher Child Care Subsidy Rate</div><Heading>{higherSubsidyPercentage}%</Heading></div> : null;
    $[42] = higherSubsidyPercentage;
    $[43] = subsidyPercentage;
    $[44] = t27;
  } else {
    t27 = $[44];
  }
  let t28;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <div>Yearly Child Care Cost</div>;
    $[45] = t28;
  } else {
    t28 = $[45];
  }
  let t29;
  if ($[46] !== yearlyCost) {
    t29 = <div className="flex flex-1 flex-col justify-center gap-2">{t28}<Heading>${yearlyCost}</Heading></div>;
    $[46] = yearlyCost;
    $[47] = t29;
  } else {
    t29 = $[47];
  }
  let t30;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <div>Secondary income after tax and child care cost</div>;
    $[48] = t30;
  } else {
    t30 = $[48];
  }
  const t31 = secondaryIncome - calculateTax(secondaryIncome) - yearlyCost;
  let t32;
  if ($[49] !== t31) {
    t32 = <div className="flex flex-1 flex-col justify-center gap-2">{t30}<Heading>${t31}</Heading></div>;
    $[49] = t31;
    $[50] = t32;
  } else {
    t32 = $[50];
  }
  let t33;
  if ($[51] !== t26 || $[52] !== t27 || $[53] !== t29 || $[54] !== t32) {
    t33 = <div className="flex flex-row flex-wrap gap-4 text-center">{t26}{t27}{t29}{t32}</div>;
    $[51] = t26;
    $[52] = t27;
    $[53] = t29;
    $[54] = t32;
    $[55] = t33;
  } else {
    t33 = $[55];
  }
  let t34;
  if ($[56] !== t14 || $[57] !== t17 || $[58] !== t24 || $[59] !== t33 || $[60] !== t8 || $[61] !== t9) {
    t34 = <CardContent className="flex flex-col gap-6">{t8}{t9}{t14}{t17}{t24}{t33}</CardContent>;
    $[56] = t14;
    $[57] = t17;
    $[58] = t24;
    $[59] = t33;
    $[60] = t8;
    $[61] = t9;
    $[62] = t34;
  } else {
    t34 = $[62];
  }
  let t35;
  if ($[63] !== t3 || $[64] !== t34) {
    t35 = <Card className="mx-auto w-full">{t3}{t34}</Card>;
    $[63] = t3;
    $[64] = t34;
    $[65] = t35;
  } else {
    t35 = $[65];
  }
  return t35;
}
export { ChildcareSubsidyCalculator };